export const FETCH_MERCHANT_LEGAL_ENTITY_REQUEST =
    'FETCH_MERCHANT_LEGAL_ENTITY_REQUEST';

export const FETCH_MERCHANT_LEGAL_ENTITY_SUCCESS =
    'FETCH_MERCHANT_LEGAL_ENTITY_SUCCESS';

export const FETCH_MERCHANT_LEGAL_ENTITY_FAILURE =
    'FETCH_MERCHANT_LEGAL_ENTITY_FAILURE';

export const CREATE_MERCHANT_LEGAL_ENTITY_REQUEST =
    'CREATE_MERCHANT_LEGAL_ENTITY_REQUEST';

export const CREATE_MERCHANT_LEGAL_ENTITY_SUCCESS =
    'CREATE_MERCHANT_LEGAL_ENTITY_SUCCESS';

export const CREATE_MERCHANT_LEGAL_ENTITY_FAILURE =
    'CREATE_MERCHANT_LEGAL_ENTITY_FAILURE';

export const FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST =
    'FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_REQUEST';

export const FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_SUCCESS =
    'FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_SUCCESS';

export const FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_FAILURE =
    'FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_FAILURE';
export const CLEAR_MERCHANT_LEGAL_ENTITY_DETAILS =
    'CLEAR_MERCHANT_LEGAL_ENTITY_DETAILS';

export const FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST =
    'FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_REQUEST';

export const FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_SUCCESS =
    'FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_SUCCESS';

export const FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_FAILURE =
    'FETCH_MERCHANT_LEGAL_ENTITY_DETAILS_PINCODE_FAILURE';



export const EDIT_MERCHANT_LEGAL_ENTITY_REQUEST =
    'EDIT_MERCHANT_LEGAL_ENTITY_REQUEST';

export const EDIT_MERCHANT_LEGAL_ENTITY_SUCCESS =
    'EDIT_MERCHANT_LEGAL_ENTITY_SUCCESS';

export const EDIT_MERCHANT_LEGAL_ENTITY_FAILURE =
    'EDIT_MERCHANT_LEGAL_ENTITY_FAILURE';

export const MERCHANT_LEGAL_ENTITY_FORM_RESET =
    'MERCHANT_LEGAL_ENTITY_FORM_RESET';

export const SET_STATIC_MERCHANT_LEGAL_ENTITY = "SET_STATIC_MERCHANT_LEGAL_ENTITY"

export const FETCH_BASIC_FORM_DATA_FAILURE_V1 = 'FETCH_BASIC_FORM_DATA_FAILURE';
export const FETCH_BASIC_FORM_DATA_PROCESS_V1 = 'FETCH_BASIC_FORM_DATA_PROCESS';
export const FETCH_BASIC_FORM_DATA_SUCCESS_V1 = 'FETCH_BASIC_FORM_DATA_SUCCESS';

// save and continue api
export const SAVE_AND_CONTINUE_REQUEST_V1 = 'SAVE_AND_CONTINUE_REQUEST_V1';
export const SAVE_AND_CONTINUE_SUCCESS_V1 = 'SAVE_AND_CONTINUE_SUCCESS_V1';
export const SAVE_AND_CONTINUE_FAILED_V1 = 'SAVE_AND_CONTINUE_FAILED_V1';

export const RESET_SUCCESS_KEY = 'RESET_SUCCESS_KEY';
export const RESET_FORM_DATA_MLE = 'RESET_FORM_DATA_MLE';

export const FETCH_MLE_FORM_IN_PROCESS_REQUEST = 'FETCH_MLE_FORM_IN_PROCESS_REQUEST';
export const FETCH_MLE_FORM_IN_PROCESS_SUCCESS = 'FETCH_MLE_FORM_IN_PROCESS_SUCCESS';
export const FETCH_MLE_FORM_IN_PROCESS_ERROR = 'FETCH_MLE_FORM_IN_PROCESS_ERROR';

export const SUBMIT_REQUEST_DATA_MLE = 'SUBMIT_REQUEST_DATA_MLE';

export const SUBMIT_SUCCESS_DATA_MLE = 'SUBMIT_SUCCESS_DATA_MLE';

export const SUBMIT_FAILURE_DATA_MLE = 'SUBMIT_FAILURE_DATA_MLE';

export const REDIRECT_KEY_MLE = 'REDIRECT_KEY_MLE';
